import { PythonTopic } from '../../../../types/python-topic';
import { trabajandoConDatosExercises } from './exercises';

export const trabajandoConDatosTopic: PythonTopic = {
  id: 2,
  title: 'Trabajando con datos',
  description: 'Aprende a procesar, formatear y trabajar con diferentes tipos de datos en Python.',
  theory: `# Trabajando con Datos en Python

## ¿Qué aprenderás en esta sección?

Esta sección te introduce a:
1. **Introducción a datos**: Conceptos fundamentales
2. **Secuencias**: Trabajar con secuencias de datos
3. **Contadores**: Contar y agrupar datos
4. **Formato de datos**: Formatear y presentar información
5. **Ejercicios prácticos**: Aplicación de conceptos

## Procesamiento de Datos

Aprenderás técnicas para:
- Procesar colecciones de datos eficientemente
- Contar y agrupar elementos
- Formatear datos para presentación
- Trabajar con diferentes estructuras de datos

## Estructura de esta sección

Cada ejercicio incluye teoría expandida, ejemplos prácticos y ejercicios para que puedas practicar a tu propio ritmo.`,
  difficulty: 'intermediate',
  exercises: trabajandoConDatosExercises
};

